export class ReplayState {
    constructor(public autoplay = false,
                public answers = false,
                public repeat = false) {}

    public setAll(autoplay, answers, repeat) {
        this.autoplay = autoplay;
        this.answers = answers;
        this.repeat = repeat;
    }
}

export class State {
    constructor(public replayStates: ReplayState = new ReplayState()) {}
}
